import { Link } from '../Link';
import { Text } from '@qcx/ui';

export interface BreadcrumbLinkProps {
  isCurrentPage?: boolean;
  children: React.ReactNode;
  href?: string;
}

export const BreadcrumbLink = ({
  children,
  isCurrentPage,
  href
}: BreadcrumbLinkProps) =>
  isCurrentPage || !href ? (
    <Text
      as="li"
      css={{
        color: '$textMuted',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      }}
      variant="sm"
      weight="semibold"
    >
      {children}
    </Text>
  ) : (
    <Text
      as="li"
      css={{ color: '$textMuted', display: 'flex', whiteSpace: 'nowrap' }}
      variant="sm"
      weight="regular"
    >
      <Link css={{ color: '$textMuted' }} to={href}>
        {children}
      </Link>
    </Text>
  );
